(() => {
    let readMoreProduct = document.querySelector('.js-product__read-more');
    let productDescription = document.querySelector('.js-product__description');

    if (readMoreProduct && productDescription) {
        readMoreProduct.addEventListener("click", function (e) {
            productDescription.classList.add('product__description--show');
            readMoreProduct.classList.add('product__read-more--hide');
        });
    }

})();

let readBadge = document.querySelector('.js-badge-block__read-more');
let descriptionBadge = document.querySelector('.js-badge-block__description');

if (readBadge && descriptionBadge) {
    readBadge.addEventListener("click", function (e) {
        descriptionBadge.classList.add('badge-block__description--show');
        readBadge.classList.add('badge-block__read-more--hide');
    });
}

let inputs = document.querySelectorAll('fieldset input');
let checkedInput = document.querySelector('.product-form__input--colors label span');
let selectors = document.querySelectorAll('.choices__list.choices__list--dropdown .choices__item span');

if (inputs && checkedInput) {
    inputs.forEach((input) => {
        if (input.checked == true) {
            checkedInput.innerHTML = input.value;
        }
    });

    inputs.forEach((input) => {
        input.addEventListener("click", function (e) {
            if (input.checked == true) {
                checkedInput.innerHTML = input.value;
            }
        });
    });
}

function addedMember() {
    var checkBox = document.querySelector(".js-member-product__checkbox");
    var buttonChecked = document.querySelector(".js-product-form__submit");
    if (checkBox && buttonChecked && checkBox.checked == true) {
        buttonChecked.click();
    }
}